function CompareToDirective() {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link: function (scope, element, attributes, ngModel) {

      ngModel.$validators.compareTo = function (modelValue) {
        return modelValue === scope.otherModelValue;
      };

      scope.$watch('otherModelValue', function () {
        ngModel.$validate();
      });
    }
  };
}

CompareToDirective.$inject = [];

export default CompareToDirective;



// WEBPACK FOOTER //
// ./src/directives/compareTo.js